import React, { FunctionComponent } from 'react'
import { ContentfulRichTextGatsbyReference } from 'gatsby-source-contentful/rich-text'

import EmailCaptureForm, {
  EmailCaptureFormProps,
} from 'components/EmailCaptureForm'

import { RTFBlockComponentExport } from '../../types'

export interface RTFContentfulNewsletterEmailCaptureGraphQLResult
  extends ContentfulRichTextGatsbyReference {
  __typename: EF.RTFBlockTypename.ContentfulNewsletterEmailCapture
  title: string
  description: string
  ctaLabel: string
  placeholder: string
  backgroundImage: EF.FluidImageNode
}

const ContentfulNewsletterEmailCaptureBlock: FunctionComponent<EmailCaptureFormProps> = (
  props
) => <EmailCaptureForm {...props} />

const componentExport: RTFBlockComponentExport = {
  component: ContentfulNewsletterEmailCaptureBlock,
  isValid: ({ title, ctaLabel, description }) =>
    !!title && !!ctaLabel && !!description,
}

export default componentExport
